var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-overflow-auto"},[_c('div',{class:[
      'tw-mt-2 tw-py-2 bg-black-11 tw-cursor-pointer',
      { 'tw-rounded-l-32 tw-pl-8 tw-pr-2 tw-ml-2' : _vm.textIsSelf },
      { 'tw-rounded-r-32 tw-pr-8 tw-pl-2 tw-mr-2' : !_vm.textIsSelf },
    ],on:{"click":function($event){return _vm.viewTaskDetails(_vm.resource)}}},[_c('p',{staticClass:"tw-text-xs opacity-31 tw-uppercase"},[_vm._v("Task")]),_c('h4',{staticClass:"tw-font-bold tw-text-sm leading-17 tw-mb-2 opacity-54"},[_vm._v(" "+_vm._s(_vm.resource.task_name)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }